import { createDivIn, createHeaderIn, createLinkIn, createParagraphIn, createSpanIn, setElementOnClick } from '../ui_utils/DomUtils.ts';
import { PatchNoteType } from '@colonist/types';
import { getProfileURI } from '../ui_utils/TestableClientUtils.ts';
import { TimeUtils } from '../../../../shared/utils/TimeUtils.ts';
import { showPatchNoteImageDialog } from '../ui_popup/showPatchNoteImageDialog.ts';
export class PatchNoteView {
    static createContentType(content, div) {
        if (content.link == undefined) {
            createSpanIn(div, PatchNoteView.getTypeClass(content.type), {
                key: 'strings:colonistCommon.utils.#buffer',
                options: {
                    value: content.type.toString()
                }
            });
            return;
        }
        const link = createLinkIn(div, content.link, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: content.type.toString()
            }
        }, PatchNoteView.getTypeClass(content.type));
        link.target = '_blank';
        link.style.textDecoration = 'underline';
    }
    static getContributorText(contributors) {
        if (contributors.length == 0) return '';
        let text = ' (Thanks';
        for (const [index, contributor] of contributors.entries()){
            text += ' <a href="' + getProfileURI(contributor) + '" target="_blank">' + contributor + '</a>';
            if (index != contributors.length - 1) text += ',';
        }
        return text + ')';
    }
    static createBeforeText(container, content) {
        if (content.beforeImgUrl == undefined) return;
        createSpanIn(container, '', {
            key: 'strings:popups.patchNote.before',
            options: {
                context: 'description'
            }
        });
        if (PatchNoteView.isExternalLink(content.beforeImgUrl)) {
            createLinkIn(container, content.beforeImgUrl, {
                key: 'strings:colonistCommon.utils.#buffer',
                options: {
                    value: '⬅️'
                }
            }, 'pn-image-link', undefined, true);
        } else {
            const beforeIcon = createSpanIn(container, 'pn-image-link', {
                key: 'strings:colonistCommon.utils.#buffer',
                options: {
                    value: '⬅️'
                }
            });
            setElementOnClick(beforeIcon, ()=>{
                void showPatchNoteImageDialog({
                    title: {
                        key: 'strings:popups.patchNote.before'
                    },
                    imagePath: content.beforeImgUrl
                });
            });
        }
        if (content.afterImgUrl == undefined) return;
        createSpanIn(container, '', {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: ' '
            }
        });
    }
    static createAfterText(container, content) {
        if (content.afterImgUrl == undefined) return;
        createSpanIn(container, '', {
            key: 'strings:popups.patchNote.after',
            options: {
                context: 'description'
            }
        });
        if (PatchNoteView.isExternalLink(content.afterImgUrl)) {
            createLinkIn(container, content.afterImgUrl, {
                key: 'strings:colonistCommon.utils.#buffer',
                options: {
                    value: '➡️'
                }
            }, 'pn-image-link', undefined, true);
            return;
        }
        const afterIcon = createSpanIn(container, 'pn-image-link', {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: '➡️'
            }
        });
        setElementOnClick(afterIcon, ()=>{
            void showPatchNoteImageDialog({
                title: {
                    key: 'strings:popups.patchNote.after'
                },
                imagePath: content.afterImgUrl
            });
        });
    }
    static getTypeClass(type) {
        switch(type){
            case PatchNoteType.Feature:
                return 'pntype-feature';
            case PatchNoteType.Update:
                return 'pntype-update';
            case PatchNoteType.Blog:
                return 'pntype-blog';
            case PatchNoteType.Fix:
                return 'pntype-fix';
            case PatchNoteType.Youtube:
                return 'pntype-youtube';
        }
    }
    static isExternalLink(link) {
        return link.includes('http');
    }
    constructor(pn, container, sidebarContainer, divClass, headerClass, bodyClass){
        const dateTextId = TimeUtils.getDate(pn.date);
        const dateFormatParams = {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        };
        const dateTitleText = {
            key: 'strings:colonistCommon.utils.#date',
            options: {
                value: pn.date,
                formatParams: {
                    value: dateFormatParams
                }
            }
        };
        const dateSidebarText = {
            key: 'strings:popups.patchNote.versionDate',
            options: {
                version: pn.version,
                date: pn.date,
                formatParams: {
                    date: dateFormatParams
                }
            }
        };
        const pndiv = createDivIn(container, divClass, dateTextId);
        const headerDiv = createDivIn(pndiv, headerClass);
        const dateTitle = createHeaderIn(headerDiv, dateTitleText, 'pn-title-date', dateTextId, 'H2');
        if (sidebarContainer !== null) {
            const sidebarLink = createLinkIn(sidebarContainer, '#' + dateTextId, dateSidebarText, 'singleton_page_sidebar_button');
        }
        const versionTitle = createHeaderIn(headerDiv, {
            key: 'strings:popups.patchNote.version',
            options: {
                version: pn.version
            }
        }, 'pn-title-version', '', 'H4');
        const bodyDiv = createDivIn(pndiv, bodyClass, '');
        for (const content of pn.contents){
            const contentDiv = createDivIn(bodyDiv, 'content', '');
            PatchNoteView.createContentType(content, contentDiv);
            const contributorText = PatchNoteView.getContributorText(content.contributors);
            const paragraph = createParagraphIn(contentDiv, {
                key: 'strings:colonistCommon.utils.emptyString'
            }, '');
            // eslint-disable-next-line no-restricted-syntax
            paragraph.innerHTML += content.description;
            // eslint-disable-next-line no-restricted-syntax
            paragraph.innerHTML += contributorText;
            if (content.beforeImgUrl != undefined || content.afterImgUrl != undefined) {
                const imageLinksContainer = createSpanIn(paragraph, '', {
                    key: 'strings:colonistCommon.utils.#buffer',
                    options: {
                        value: ' ('
                    }
                });
                PatchNoteView.createBeforeText(imageLinksContainer, content);
                PatchNoteView.createAfterText(imageLinksContainer, content);
                createSpanIn(imageLinksContainer, '', {
                    key: 'strings:colonistCommon.utils.#buffer',
                    options: {
                        value: ' )'
                    }
                });
            }
        }
    }
}
